export default "__VITE_ASSET__af3e166d__"